module.exports = "/images/report-icon.svg?86b0ce4079280ea810e59c77fd557c2d";